import axios, { AxiosRequestConfig } from 'axios'
import { defaultsDeep } from 'lodash'
import { handleFulfilled, handleRejected } from './interceptors'

const getConfig = () => {
  return {
    headers: {
      Accept: 'application/json',
    },
  }
}

const api = (baseURL: string, config?: AxiosRequestConfig) => {
  const axiosApi = axios.create({ baseURL, ...config })

  axiosApi.request = async <TData>(path: string, config?: AxiosRequestConfig): Promise<TData> => {
    const mergedConfig = defaultsDeep(config, getConfig()) as AxiosRequestConfig

    const response = await axiosApi<TData>(path, mergedConfig)
    return response.data as unknown as TData
  }

  axiosApi.interceptors.request.use(handleFulfilled, handleRejected)

  return axiosApi
}

export default api
